import decode from 'jwt-decode';

/**
 * Return the expiration time of the given token if it exists.  Otherwise,
 * returns `null`.
 *
 * @method getTokenExpirationDate
 * @param {String} token - An encoded JSON web token.
 * @returns {Object} A Date object representing the token's expiration time.
 */
export function getTokenExpirationDate(token) {
  const decoded = decode(token);
  if (!decoded.exp)
    return null;

  return new Date(decoded.exp * 1000);
}

/**
 * Returns true if the given encoded token has expired.
 *
 * @method  isTokenExpired
 * @param  {String} token [jwt token]
 * @return {Boolean}       [whether the token is expired]
 */
export function isTokenExpired(token) {
  const exp = getTokenExpirationDate(token);
  if (exp === null)
    return true;

  const now = new Date();
  return (now.getTime() >= exp.getTime());
}



// WEBPACK FOOTER //
// ./src/client/helpers/utilities/token-helpers.js